import { render, staticRenderFns } from "./excellentWorks.vue?vue&type=template&id=0788bcb5&scoped=true&"
import script from "./excellentWorks.vue?vue&type=script&lang=js&"
export * from "./excellentWorks.vue?vue&type=script&lang=js&"
import style0 from "./excellentWorks.vue?vue&type=style&index=0&id=0788bcb5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0788bcb5",
  null
  
)

export default component.exports